<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  
  let {
    value,
    id,
    selected = false,
    onMouseUp = () => {},
    onClick = () => {},
    onKeyPress = () => {},
    dataTestId = 'styled-radio-button',
    children
  } = $props();
</script>

<div class="w-full mx-2 mt-2 group" data-testid={dataTestId}>
  <input
    {id}
    type="radio"
    {value}
    name="forms"
    class="visually-hidden"
    checked={selected}
    onkeypress={onKeyPress}
    data-testid="{dataTestId}-input-{id}"
  />
  <!-- svelte-ignore a11y_click_events_have_key_events -->
  <!-- svelte-ignore a11y_no_noninteractive_element_interactions -->
  <label
    for={id}
    class="flex flex-row relative w-full justify-between text-base text-white font-semibold leading-relaxed p-5
    rounded-lg cursor-pointer active:shadow-active shadow-y-sm pseudo-shadow-tight-hover"
    class:text-blue-navy={!selected}
    class:text-white={selected}
    class:bg-white={!selected}
    class:bg-blue-cerulean={selected}
    class:hover:bg-blue-darkish={selected}
    class:active:bg-blue-darkish={selected}
    class:focus:bg-blue-darkish={selected}
    class:focus-within:bg-blue-darkish={selected}
    class:focus-within:shadow-focus={selected}
    class:focus-within:duration-0={selected}
    onmouseup={() => onMouseUp({ target: { value } })}
    onclick={() => onClick({ target: { value } })}
    data-testid="{dataTestId}-label-{id}"
  >
    {@render children?.()}
    <svg
      class="flex-none w-6 h-6 fill-current hover-hover:group-hover:opacity-100 group-active:opacity-100"
      class:opacity-0={!selected}
      class:opacity-100={selected}
      class:text-gray-light-silver={!selected}
      class:text-white={selected}
      role="presentation"
      data-testid="{dataTestId}-check"
    >
      <use xlink:href="{SPRITESHEET_URL}#check" />
    </svg>
  </label>
</div>
